const Action = require("../../entities/Action");
const {Age}  = require("../Constants");
const ActionNames = require("../Names/ActionNames");

class UrbanGrowth extends Action {
    constructor(age){
        super(
            age,
            ActionNames.UrbanGrowth, 
            `Build or upgrade an urban building; pay ${UrbanGrowth.GetResourceAmount(age)} resources less.`,
            {
                playerStateAltering:
                (playerState) => {
                    //Do stuff
                }
            },
            {}
        )
    }

    static GetResourceAmount(age){
        switch (age)
        {
            default:
                return null;
            case Age.AgeA:
                return 1;
            case Age.Age1:
                return 2;
            case Age.Age2:
                return 3;
            case Age.Age3:
                return 4;
        }
    }
}

module.exports = UrbanGrowth;
